import baseRoute from '../baseRoute';

export default `${baseRoute}/jobWorkSummary` as const;
